import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { Subscription } from 'rxjs';

import { DialogService, SnackbarService } from '../../services/';
import { TermsAndConditionsService } from '../../services';
import { CancelPolicyComponent } from './cancel-policy';
import { Response } from '../../models';

@Component({
  selector: 'prism-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  disableAndShowLoader = false;
  policy$: Observable<string> = this.tacService.policy$;
  getPolicySub: Subscription;

  constructor(private router: Router,
              private snackbarService: SnackbarService,
              private dialogService: DialogService,
              private tacService: TermsAndConditionsService) {
  }

  ngOnInit() {
    this.getPolicySub = this.tacService.getPolicies().subscribe(
      (policyResponse: Response) => {
        if (!policyResponse.data['body']) {
          this.router.errorHandler(`Could not find policy`);
        }
      },
      err => {
        this.router.errorHandler(err);
      },
      () => this.getPolicySub.unsubscribe()
    );
  }

  acceptPolicy() {
    this.disableAndShowLoader = true;
    this.tacService.acceptAndUpdateProcessor()
      .subscribe(
        () => {
          this.router.navigate(['home', 'jobs']);
        },
        err => {
          this.disableAndShowLoader = false;
          this.snackbarService.handleError(`Oh no! Something went wrong, please try again.`);
          console.error('Could not update Member:', err);
        }
      );
  }

  openCancelPolicyDialog() {
    this.dialogService.openDialog(CancelPolicyComponent, {}, {panelClass: 'base-modal-dialog'});
  }

}

